export default __webpack_public_path__ + "static/media/HardDrive.256.31113633.png";